import { RAG_RATING } from 'helpers/sicHelper';

export const buildSicTableStyles = isDark => {
  const borderColor = isDark ? '#4a4f58' : '#c4c9d0';
  const cellBorder = `1px solid ${borderColor}`;

  return {
    borderColor,
    headerCell: {
      backgroundColor: isDark ? 'rgb(34 45 59)' : '#d8e2ef',
      color: isDark ? 'white' : '#000000',
      fontWeight: 'bold',
      fontSize: '0.75rem',
      border: cellBorder,
      padding: '6px 8px',
      textAlign: 'center',
      verticalAlign: 'middle',
      whiteSpace: 'nowrap'
    },
    weekendHeaderCell: {
      backgroundColor: isDark ? '#2c3a4d' : '#c9d6e8'
    },
    bodyCell: {
      fontSize: '0.8rem',
      border: cellBorder,
      padding: '4px 8px',
      verticalAlign: 'middle',
      color: isDark ? 'white' : 'black'
    },
    zebraBackground: rowIndex =>
      rowIndex % 2 === 0
        ? isDark
          ? '#1e1e2f'
          : '#ffffff'
        : isDark
        ? '#262838'
        : 'aliceblue',
    sicRowCell: {
      fontSize: '0.8rem',
      fontWeight: 'bold',
      border: cellBorder,
      padding: '6px 8px',
      textAlign: 'center',
      verticalAlign: 'middle',
      backgroundColor: isDark ? '#2a3445' : '#eef2f8',
      color: isDark ? 'white' : 'black'
    },
    passColors: {
      backgroundColor: isDark ? 'rgba(0, 210, 122, 0.22)' : '#d4edda',
      color: isDark ? '#7ee2b8' : '#155724'
    },
    failColors: {
      backgroundColor: isDark ? 'rgba(230, 55, 87, 0.25)' : '#f8d7da',
      color: isDark ? '#f59fae' : '#721c24'
    },
    amberColors: {
      backgroundColor: isDark ? 'rgba(245, 128, 62, 0.25)' : '#fff3cd',
      color: isDark ? '#f8c48f' : '#856404'
    }
  };
};

export const resultColors = (styles, isPassing) => {
  if (isPassing === null || isPassing === undefined) return {};
  return isPassing ? styles.passColors : styles.failColors;
};

export const ragRatingColors = (styles, ragValue) => {
  switch (Number(ragValue)) {
    case RAG_RATING.green:
      return styles.passColors;
    case RAG_RATING.amber:
      return styles.amberColors;
    case RAG_RATING.red:
      return styles.failColors;
    default:
      return {};
  }
};

export const SIC_COLUMN_WIDTHS = {
  measurable: 220,
  uom: 70,
  compare: 75,
  target: 120,
  affectsSic: 90,
  day: 125,
  total: 100
};

export const SIC_LEADING_COLUMNS_WIDTH =
  SIC_COLUMN_WIDTHS.measurable +
  SIC_COLUMN_WIDTHS.uom +
  SIC_COLUMN_WIDTHS.compare +
  SIC_COLUMN_WIDTHS.target +
  SIC_COLUMN_WIDTHS.affectsSic;

export const SIC_DAY_COUNT = 7;

export const SIC_TABLE_WIDTH =
  SIC_LEADING_COLUMNS_WIDTH +
  SIC_COLUMN_WIDTHS.day * SIC_DAY_COUNT +
  SIC_COLUMN_WIDTHS.total;

export const fixedLayoutTableStyle = {
  borderCollapse: 'collapse',
  marginBottom: 0,
  tableLayout: 'fixed',
  width: `${SIC_TABLE_WIDTH}px`
};
